import AdminGuard from '@/views/dashboard/guards/AdminGuard'
import PeriodList from './PeriodList'
import PeriodDetail from './PeriodDetail'
import PeriodTryoutDetail from './PeriodTryoutDetail'
import CreateTryout from './CreateTryout'

export default [
    {
        path: 'periode',
        component: PeriodList,
        beforeEnter: AdminGuard,
        name: 'period',
        meta: { title: 'Program' },
    },
    {
        path: 'periode/:period_id',
        component: PeriodDetail,
        beforeEnter: AdminGuard,
        name: 'period.detail',
    },
    {
        path: 'periode/:period_id/:hash',
        component: PeriodTryoutDetail,
        beforeEnter: AdminGuard,
        name: 'period.tryout.detail',
    },
    {
        path: 'periode/:period_id/tryout/buat',
        component: CreateTryout,
        beforeEnter: AdminGuard,
        name: 'period.tryout.create',
        meta: { title: 'Buat tryout baru' },
    },
]
